import {Model} from 'vue-mc';


/**
 * ItProject model
 */
export default class InterpreterModel extends Model {

    defaults() {
        return {
            interpreterId: "",
            fmInterpreterId: "",
            firstName: "",
            lastName: "",
            language: "",
            state: "",
            date: "",
            gender: "",
            naatiLevel: "",

        }
    }

    // Route configuration
    routes() {
        return {
            fetch: "",
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/interpreterModel.js